// React:
import React from "react";
// MUI Components:
import { Grid, useTheme } from "@mui/material";
// Components:
import UploadAndCreate from "./upload-and-create/UploadAndCreate";
import Directory from "./directory/Directory";

const Home = () => {
  const theme = useTheme();

  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          width: "100%",
          height: "fit-content",
          mb: "16px",
          [theme.breakpoints.down("md")]: {
            mb: "10px",
          },
          [theme.breakpoints.down("sm")]: {
            height: "0%",
            mb: "0px",
          },
        }}
      >
        <UploadAndCreate />
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          width: "100%",
          height: "calc(100% - 105px)",
          [theme.breakpoints.down("md")]: {
            height: "calc(100% - 84px)",
          },
          [theme.breakpoints.down("sm")]: {
            height: "100%",
          },
        }}
      >
        <Directory />
      </Grid>
    </>
  );
};

export default Home;
